import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TestDetails } from '../../../features/test/model/test-details';
import { TestInstallation } from '../../../features/test/model/test-installation';
import { HttpProvider } from '../../common/http/http-provider.service';
import { TestFilterDTO } from '../../../features/test/model/test-filter';
@Injectable()
export class TestDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  saveTestDetails(tDetails: TestDetails) {
    if (!tDetails.id || tDetails.id == 0)
      return this.post('test/SaveTestDetails', tDetails);
    else
      return this.put('test/UpdateTestDetails', tDetails);
    // if (!parameter.id) return this.post('tests', parameter);
    // else return this.put('tests/' + parameter.id, parameter);
  }
  updateTestEndReason(data: TestDetails) {
      return this.put('test/UpdateTestEndReason', data);
  }

  saveTestInstallation(tInstallation: TestInstallation) {
    if (!tInstallation.id || tInstallation.id == 0)
      return this.post('test/SaveTestInstallation', tInstallation);
    else
      return this.put('test/UpdateTestInstallation', tInstallation);
  }

  getTestDetails(id: number) {
    return this.get('test/Test/' + id);
  }

  generateItiDocument(testId: number) {
    return this.post(`test/${testId}/iti-document`, {}, { showerrormessage: false });
  }
  generateTtrDocument(testId: number) {
    return this.post(`test/${testId}/ttr-document`, {}, { showerrormessage: false });
  }
  getElementPerformance(testId: number) {
    return this.get('constructionElement/GetPerformance/' + testId);
  }
  saveTestResults(parameter: any) {
    return this.post('constructionElement/SaveElementGoal', parameter);
    // if (!parameter.id || parameter.id == 0)
    //   return this.post('testResult', parameter);
    // else return this.put('testResult/' + parameter.id, parameter);
  }

  //test page project dd
  // getProjectList(prjName: string) {
  //   return this.get('projects');
  // }

  getTestlist(projectId: number) {
    return this.get('tests?pId=' + projectId);
  }
  //here actual API will have array of elements

  saveElement(parameter: any) {
    if (!parameter.id || parameter.id == 0 || !parameter.ce_Id || parameter.ce_Id == 0)
      return this.post(
        'constructionElement/SaveConstructionElement',
        parameter
      );
    else
      return this.put(
        'constructionElement/UpdateConstructionElement/' + parameter.id,
        parameter
      );
    // return this.post('testElement', parameter);
  }

  getElement(testId: number) {
    return this.get('testElement?testId=' + testId);
  }
  //#region for Dasboard
  getAllTestDetails(params) {
    return this.get('test/getAllTest',params);
  }
  //#endregion for Dasboard

  getTestResult(testId: number) {
    return this.get('constructionElement/getGoalResult?module=2&entityId=' + testId);
  }

  getTestOverview(pId: number) {
    return this.get('test/overview/' + pId);
  }

  saveGoalresult(data: any) {
    return this.post('constructionElement/GoalResult', data); 
  }
  updateTestResult(parameter: any) {
    return this.post('constructionElement/SaveGoalResult', parameter);
    // if (!parameter.id || parameter.id == 0)
    //   return this.post('testResult', parameter);
    // else return this.put('testResult/' + parameter.id, parameter);
  }

  deletePerformance(ids: number[], elemenetId) {
    return this.post('constructionElement/' + elemenetId + '/Delete', ids);
  }

  checkTestExternal(projectId: number, testPurposeId: number) {
    return this.get('test/checkTestExternal/' + projectId, { testPurposeId: testPurposeId })
  }
  search(data: TestFilterDTO) {
    return this.post('test/search/', data);
  }

   export(data: TestFilterDTO) {
      return this.getFile<any>('test/export', data);
    }
  

  copy(data: any) {
    return this.post('test/copy/', data);
  }

  deleteTest(id: number, projectId: number) {
    return this.delete(`test/${id}/${projectId}`);
  }
}
